// ComplianceTab.js
import React, { useState, useEffect, useContext } from "react";
import { collection, getDocs, doc, updateDoc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { EnvContext } from "../../../context/EnvContext";
import { useFirestore } from "../../firebase/FirestoreContext";
import { useParams } from "react-router-dom";
import config from "../../../config";
import { ToastContainer } from "react-toastify";

const ComplianceTab = () => {
  const db = useFirestore();
  const { id } = useParams();
  const environment = useContext(EnvContext);
  const [locations, setLocations] = useState([]);
  const [selectedCompliance, setSelectedCompliance] = useState([]);
  const [loading, setLoading] = useState(false);

  const collectionPath = environment === "staging" ? config.enveironment.staging.collectionPath : config.enveironment.production.collectionPath;

  useEffect(() => {
    const fetchLocations = async () => {
      const locationsCollectionRef = collection(db, `${collectionPath}SooperstockSettings/ShipmentCompliance/DataBase`);
      const snapshot = await getDocs(locationsCollectionRef);
      const locationsArray = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setLocations(locationsArray);
    };
    fetchLocations();
  }, [db, collectionPath]);

  useEffect(() => {
    const fetchProductCompliance = async () => {
      if (id) {
        const productDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase`, id);
        const docSnap = await getDoc(productDocRef);

        if (docSnap.exists()) {
          setSelectedCompliance(docSnap.data().compliance || []);
        } else {
          console.log("No such document!");
        }
      }
    };

    fetchProductCompliance();
  }, [db, collectionPath, id]);

  const handleConstraintChange = (locationShortName) => {
    setSelectedCompliance((prev) => (prev.includes(locationShortName) ? prev.filter((item) => item !== locationShortName) : [...prev, locationShortName]));
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedCompliance(locations.map((location) => location.shortName));
    } else {
      setSelectedCompliance([]);
    }
  };

  const saveCompliance = async () => {
    setLoading(true);
    try {
      const productDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase`, id);
      await updateDoc(productDocRef, {
        compliance: selectedCompliance,
        compliance_type: "custom",
      });
      toast.success("Compliance saved successfully!"); // Success toast
    } catch (error) {
      console.error("Error saving compliance:", error);
      toast.error("Failed to save compliance."); // Error toast
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ ...styles.container, ...styles.form }}>
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable />

      <h2>Manage Product Compliance</h2>
      <div style={styles.selectAll}>
        <label>
          <input
            type="checkbox"
            checked={selectedCompliance.length === locations.length && locations.length > 0}
            onChange={(e) => handleSelectAll(e.target.checked)}
          />
          Select/Unselect All
        </label>
      </div>
      <div style={styles.locationsGrid}>
        {locations.map((location) => (
          <div key={location.id} style={styles.locationItem}>
            <span>
              {location.name} ({location.shortName})
            </span>
            <input type="checkbox" checked={selectedCompliance.includes(location.shortName)} onChange={() => handleConstraintChange(location.shortName)} />
          </div>
        ))}
      </div>
      <button onClick={saveCompliance} style={{ ...styles.button, backgroundColor: loading ? "silver" : "#478169" }} disabled={loading}>
        {loading ? "Saving..." : "Save Compliance"}
      </button>
    </div>
  );
};

const styles = {
  container: {
    padding: 20,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: 300,
    border: "1px solid #ccc",
    flex: 1,
    borderRadius: 5,
    backgroundColor: "#f9f9f9",
    width: "100%",
  },
  selectAll: {
    marginBottom: 10,
  },
  locationsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "10px",
  },
  locationItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #ccc",
    padding: "5px 10px",
    borderRadius: 4,
  },
  button: {
    padding: "0px 20px",
    width: "auto",
    color: "white",
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
    fontSize: 14,
    height: 50,
  },
};

export default ComplianceTab;
